import React from 'react';
import { UrlService } from '@sm360/widget-commons-core-services';

let newTradeInURLParam = false;
if (UrlService.getUrlParameter('newTradeIn') && UrlService.getUrlParameter('newTradeIn') === 'true') {
    newTradeInURLParam = true;
}
// TODO: newTradeIn - Remove this file after deploy new tradeIn to the PROD
const NewTradeInContext = React.createContext({
    displayNewTradeIn: newTradeInURLParam,
    fieldsLocked: false,
    setFieldsLocked: () => {},
});

export const NewTradeInProvider = NewTradeInContext.Provider;
export const NewTradeInConsumer = NewTradeInContext.Consumer;

export default NewTradeInContext;
